/*
  Omnify setup fee.
  A subscription service that carries a setup fee brings the one time Agent Hardware Fee with it:
  one fee line, quantity 1, no selling plan, however many fee bearing services sit in the cart.
  The fee line is removed when no fee bearing service remains.

  Data sources (nothing hardcoded here):
    - product page: <product-info data-product-id data-omnify-fee-variant> rendered from the product metafield
      omnify.setup_fee_variant in sections/main-product.liquid
    - every page: the script tag's data-fee-map ("productId:feeVariantId,...") rendered in layout/theme.liquid
      from products tagged setup-fee, plus data-cart-count
    - fallback for products missing from the map: /products/{handle}.js tags (contains "setup-fee")
*/
(function () {
  'use strict';
  if (window.OmnifySetupFee) return;

  var script = document.currentScript || document.getElementById('omnify-setup-fee-script');
  var ds = (script && script.dataset) || {};
  var FEE_PROP = '_omnify_fee';
  var TAG = 'setup-fee';
  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  if (!nativeFetch) return;

  var feeMap = {};
  var feeVariants = {};
  var defaultFeeVariant = null;
  String(ds.feeMap || '').split(',').forEach(function (pair) {
    var parts = pair.split(':');
    if (parts.length === 2 && parts[0] && parts[1]) {
      feeMap[parts[0].trim()] = parts[1].trim();
      feeVariants[parts[1].trim()] = true;
      if (!defaultFeeVariant) defaultFeeVariant = parts[1].trim();
    }
  });

  // 2026-09-23: each service carries its own fee variant (omnify.setup_fee_variant, mirrored in the tag
  // setup-fee-variant-<id>). One fee line per distinct fee variant: the shared hardware fee stays one line for every
  // hardware service, a site specific fee (call tracking, review acquisition) gets its own line.
  var VARIANT_TAG = 'setup-fee-variant-';
  var tagMemo = {};
  try {
    tagMemo = JSON.parse(sessionStorage.getItem('omnify-fee-tags-v2') || '{}') || {};
  } catch (e) {
    tagMemo = {};
  }

  function json(url, opts) {
    opts = opts || {};
    opts.credentials = 'same-origin';
    opts.headers = Object.assign({ Accept: 'application/json' }, opts.headers || {});
    if (opts.body && typeof opts.body !== 'string') {
      opts.body = JSON.stringify(opts.body);
      opts.headers['Content-Type'] = 'application/json';
    }
    return nativeFetch(url, opts).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) {
          var err = new Error('cart request failed ' + r.status);
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  function pageFeeVariant(productId) {
    var el = document.querySelector('product-info[data-product-id="' + productId + '"]');
    if (!el) return null;
    var v = el.getAttribute('data-omnify-fee-variant');
    return v && v.trim() ? v.trim() : null;
  }

  function isFeeLine(item) {
    if (item.properties && item.properties[FEE_PROP]) return true;
    return !!feeVariants[String(item.variant_id)];
  }

  // Resolves the fee variant a cart line needs (null when the product carries no setup fee).
  function feeVariantFor(item) {
    var pid = String(item.product_id);
    var v = pageFeeVariant(pid) || feeMap[pid] || null;
    if (v) return Promise.resolve(v);
    if (Object.prototype.hasOwnProperty.call(tagMemo, pid)) {
      return Promise.resolve(tagMemo[pid] || null);
    }
    if (!item.handle) return Promise.resolve(null);
    return json('/products/' + item.handle + '.js')
      .then(function (p) {
        var tags = Array.isArray(p.tags) ? p.tags : [];
        var fee = null;
        if (tags.indexOf(TAG) !== -1) {
          tags.forEach(function (t) {
            if (!fee && String(t).indexOf(VARIANT_TAG) === 0) fee = String(t).slice(VARIANT_TAG.length);
          });
          if (!fee) fee = defaultFeeVariant;
        }
        if (fee) feeVariants[fee] = true;
        tagMemo[pid] = fee || '';
        try {
          sessionStorage.setItem('omnify-fee-tags-v2', JSON.stringify(tagMemo));
        } catch (e) {}
        return fee;
      })
      .catch(function () {
        return null;
      });
  }

  function changeLine(key, quantity) {
    return json('/cart/change.js', { method: 'POST', body: { id: key, quantity: quantity } });
  }

  function addFee(variantId) {
    var props = {};
    props[FEE_PROP] = '1';
    return json('/cart/add.js', {
      method: 'POST',
      body: { items: [{ id: Number(variantId), quantity: 1, properties: props }] }
    });
  }

  // Re-render the cart drawer, the cart page and the header bubble from the Section Rendering API.
  function refresh(cart) {
    var wanted = [];
    var drawer = document.getElementById('CartDrawer');
    var bubble = document.getElementById('cart-icon-bubble');
    var cartItems = document.getElementById('main-cart-items');
    var cartFooter = document.getElementById('main-cart-footer');
    if (drawer) wanted.push('cart-drawer');
    if (bubble) wanted.push('cart-icon-bubble');
    if (cartItems && cartItems.dataset.id) wanted.push(cartItems.dataset.id);
    if (cartFooter && cartFooter.dataset.id) wanted.push(cartFooter.dataset.id);
    if (!wanted.length) return Promise.resolve();
    // Section Rendering API. Note: an Accept: application/json header makes /cart answer with cart JSON instead.
    return nativeFetch('/cart?sections=' + wanted.join(','), { credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (sections) {
      var parse = function (html) {
        return new DOMParser().parseFromString(html || '', 'text/html');
      };
      var empty = !cart || cart.item_count === 0;
      if (drawer && sections['cart-drawer']) {
        var src = parse(sections['cart-drawer']).getElementById('CartDrawer');
        if (src) drawer.innerHTML = src.innerHTML;
        var drawerEl = document.querySelector('cart-drawer');
        if (drawerEl) {
          drawerEl.classList.toggle('is-empty', empty);
          var overlay = document.getElementById('CartDrawer-Overlay');
          if (overlay && typeof drawerEl.close === 'function') {
            overlay.addEventListener('click', drawerEl.close.bind(drawerEl));
          }
        }
      }
      if (bubble && sections['cart-icon-bubble']) {
        var b = parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
        if (b) bubble.innerHTML = b.innerHTML;
      }
      if (cartItems && sections[cartItems.dataset.id]) {
        var target = cartItems.querySelector('.js-contents') || cartItems;
        var source = parse(sections[cartItems.dataset.id]).querySelector('.js-contents');
        if (source) target.innerHTML = source.innerHTML;
        var ci = document.querySelector('cart-items');
        if (ci) ci.classList.toggle('is-empty', empty);
      }
      if (cartFooter && sections[cartFooter.dataset.id]) {
        var ft = cartFooter.querySelector('.js-contents') || cartFooter;
        var fs = parse(sections[cartFooter.dataset.id]).querySelector('.js-contents');
        if (fs) ft.innerHTML = fs.innerHTML;
        cartFooter.classList.toggle('is-empty', empty);
      }
    });
  }

  // Two passes: a theme or app render that was already in flight when the fee changed can land after the first one.
  function refreshTwice(cart) {
    return refresh(cart).then(function () {
      setTimeout(function () {
        refresh(cart).catch(function () {});
      }, 1500);
    });
  }

  var busy = false;
  var pending = false;
  var timer = null;
  var failures = 0;

  function reconcile() {
    if (busy) {
      pending = true;
      return;
    }
    busy = true;
    var changed = false;
    var lastCart = null;
    json('/cart.js')
      .then(function (cart) {
        lastCart = cart;
        var services = cart.items.filter(function (i) {
          return !isFeeLine(i);
        });
        return Promise.all(services.map(feeVariantFor)).then(function (variants) {
          var needed = {};
          variants.forEach(function (v) {
            if (v) needed[String(v)] = true;
          });
          var present = {};
          var ops = [];
          cart.items.forEach(function (item) {
            if (!isFeeLine(item)) return;
            var v = String(item.variant_id);
            // Keep exactly one plain (no selling plan) fee line per needed fee variant; drop the rest.
            // A fee line that arrived on a selling plan is dropped here and re-added as a one time line below.
            var keep = needed[v] && !present[v] && !item.selling_plan_allocation;
            if (!keep) {
              ops.push(function () {
                return changeLine(item.key, 0);
              });
              return;
            }
            present[v] = true;
            if (item.quantity !== 1) {
              ops.push(function () {
                return changeLine(item.key, 1);
              });
            }
          });
          Object.keys(needed).forEach(function (v) {
            if (!present[v]) {
              ops.push(function () {
                return addFee(v);
              });
            }
          });
          if (!ops.length) return null;
          changed = true;
          return ops.reduce(function (p, op) {
            return p.then(op);
          }, Promise.resolve());
        });
      })
      .then(function () {
        if (!changed) return null;
        return json('/cart.js').then(function (cart) {
          lastCart = cart;
          return refreshTwice(cart);
        });
      })
      .then(function () {
        failures = 0;
        if (changed) {
          try {
            document.dispatchEvent(new CustomEvent('omnify:setup-fee', { detail: { cart: lastCart } }));
          } catch (e) {}
        }
      })
      .catch(function (err) {
        failures += 1;
        if (failures <= 2) {
          console.warn('Setup fee check skipped:', (err && err.data && (err.data.description || err.data.message)) || (err && err.message) || err);
        }
      })
      .then(function () {
        busy = false;
        if (pending) {
          pending = false;
          schedule();
        }
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      timer = null;
      reconcile();
    }, 250);
  }

  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  // Any cart mutation from the theme or an app (fetch or XHR) triggers a re-check.
  window.fetch = function (input, init) {
    var p = nativeFetch(input, init);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (CART_RE.test(url)) {
        p.then(
          function (r) {
            if (r && r.ok) schedule();
          },
          function () {}
        );
      }
    } catch (e) {}
    return p;
  };

  try {
    var open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (CART_RE.test(String(url))) {
          this.addEventListener('load', function () {
            if (this.status >= 200 && this.status < 300) schedule();
          });
        }
      } catch (e) {}
      return open.apply(this, arguments);
    };
  } catch (e) {}

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
    try {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        schedule();
      });
    } catch (e) {}
  }

  window.addEventListener('pageshow', function (evt) {
    if (evt.persisted) schedule();
  });

  if (Number(ds.cartCount || 0) > 0) schedule();

  window.OmnifySetupFee = {
    reconcile: reconcile,
    refresh: function () {
      return json('/cart.js').then(refreshTwice);
    },
    feeMap: feeMap,
    isBusy: function () {
      return busy || pending || timer !== null;
    }
  };
})();
